function backendBearerCredential(sessionId, organizationId, token) {
  const t = typeof token === "string" ? token.trim() : "";
  if (t.includes("&")) return t;
  const sid = String(sessionId || "").trim();
  const oid = String(organizationId || "").trim();
  return `${sid}&${oid}`;
}

export async function saveComputervsPersonResult({
  sessionId,
  organizationId,
  userId,
  token,
  playerName,
  opponentName = "Computer",
  winner,
  playerPoints,
  opponentPoints,
  totalTime,
  reportId,
}) {
  const bearer = backendBearerCredential(sessionId, organizationId, token);
  const resp = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/saveComputervsPersonResult`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearer}`,
      },
      body: JSON.stringify({
        sessionId,
        organizationId,
        userId,
        playerName,
        opponentName,
        winner,
        playerPoints,
        opponentPoints,
        totalTime,
        ...(reportId != null && String(reportId).trim() !== ""
          ? { reportId: String(reportId).trim() }
          : {}),
      }),
    }
  );

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(
      data?.message || data?.error || "Failed to save vs computer result"
    );
  }
  return data;
}
